import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import type { ExternalAssetsGroupByField } from './external-assets-table/external-assets-table.model';

export function useExternalAssetsGroupByLabel() {
  const tDetail = useTranslations('externalNetwork.assetDetail');
  const tList = useTranslations('externalNetwork.assetList');
  const tFilters = useTranslations('externalNetwork.assetFilters');

  return useCallback(
    (field: ExternalAssetsGroupByField): string => {
      switch (field) {
        case 'scope':
          return tDetail('scope');
        case 'sourceType':
          return tDetail('source');
        case 'organization':
          return tFilters('organization');
        case 'isTopLevel':
          return tList('columns.level');
        case 'cloudProvider':
          return tDetail('cloudProvider');
        case 'providerCategory':
          return tList('columns.function');
        case 'transportProtocol':
          return tDetail('transport');
        case 'softwareType':
          return tDetail('softwareType');
        case 'vendor':
          return tDetail('vendor');
        case 'provider':
          return tDetail('provider');
      }
    },
    [tDetail, tFilters, tList],
  );
}
